/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Is_Sellable_HintInputs */

const vi_product_is_sellable_hint = /** @type {(inputs: Product_Is_Sellable_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bỏ tick nếu sản phẩm chỉ dùng để ghép combo, không bán riêng (sẽ ẩn khỏi picker bán hàng).`)
};

/**

* @param {Product_Is_Sellable_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_is_sellable_hint = /** @type {((inputs?: Product_Is_Sellable_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Is_Sellable_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_is_sellable_hint(inputs)
});